import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddProject from '../AddProject';
import SearchProjectCreation from '../EmployerInvitesConsultantToProjectModal/SearchProjectCreation';
import '../EmployerInvitesConsultantToProjectModal/EmployerInvitesConsultantToProjectModal.scss';

class HireAgain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 'add',
    };

    this.setCurrentPageToCreateNew = this.setCurrentPageToCreateNew.bind(this);
    this.setCurrentPageToAddProject = this.setCurrentPageToAddProject.bind(this);
    this.afterProjectCreation = this.afterProjectCreation.bind(this);
  }

  setCurrentPageToCreateNew() {
    this.setState({ currentPage: 'create' });
  }

  setCurrentPageToAddProject() {
    this.setState({ currentPage: 'add' });
  }

  afterProjectCreation(projectResourceId) {
    const newUrl = `/projects/${projectResourceId}`;

    window.location.href = newUrl; // go to newly created project page.
  }

  renderPage() {
    const {
      consultant,
      projectsToDuplicate,
      durationOptions,
      timePerWeekOptions,
      workLocationOptions,
      companyId,
      csrfToken,
      isRep,
      projectTemplates,
    } = this.props;
    const { currentPage } = this.state;

    if (currentPage === 'add') {
      return (
        <div className="projects-add_project">
          <AddProject
            projects={projectsToDuplicate}
            consultant={consultant}
            hireAgain
            onCreateNewProject={() => this.setCurrentPageToCreateNew()}
            projectTemplates={projectTemplates}
            csrfToken={csrfToken}
          />
        </div>
      );
    } if (currentPage === 'create') {
      return (
        <div className="style-guide employer-invites-consultant-to-project">
          <div className="modal-body">
            <SearchProjectCreation
              hireAgain
              backToProjectSelection={() => this.setCurrentPageToAddProject()}
              companyId={companyId}
              isRep={isRep}
              consultant={consultant}
              workLocationOptions={workLocationOptions}
              durationOptions={durationOptions}
              timePerWeekOptions={timePerWeekOptions}
              csrfToken={csrfToken}
              handleInvited={(newProjectResId) => this.afterProjectCreation(newProjectResId)}
            />
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div>
        {this.renderPage()}
      </div>
    );
  }
}

HireAgain.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  companyId: PropTypes.number,
  isRep: PropTypes.bool.isRequired,
  projectsToDuplicate: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.string)]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.string)]).isRequired,
  projectTemplates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

HireAgain.defaultProps = {
  companyId: 0,
};

export default HireAgain;
